import {type IconDefinition} from '@fortawesome/fontawesome-svg-core'
export default {
    'amilia': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faAmilia" */
        '@fortawesome/free-brands-svg-icons/faAmilia'
    ),
    'app-store-ios': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faAppStoreIos" */
        '@fortawesome/free-brands-svg-icons/faAppStoreIos'
    ),
    'buy-n-large': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faBuyNLarge" */
        '@fortawesome/free-brands-svg-icons/faBuyNLarge'
    ),
    'buysellads': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faBuysellads" */
        '@fortawesome/free-brands-svg-icons/faBuysellads'
    ),
    'creative-commons-pd-alt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faCreativeCommonsPdAlt" */
        '@fortawesome/free-brands-svg-icons/faCreativeCommonsPdAlt'
    ),
    'dev': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faDev" */
        '@fortawesome/free-brands-svg-icons/faDev'
    ),
    'fedora': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faFedora" */
        '@fortawesome/free-brands-svg-icons/faFedora'
    ),
    'firstdraft': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faFirstdraft" */
        '@fortawesome/free-brands-svg-icons/faFirstdraft'
    ),
    'flickr': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faFlickr" */
        '@fortawesome/free-brands-svg-icons/faFlickr'
    ),
    'font-awesome-logo-full': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faFontAwesomeLogoFull" */
        '@fortawesome/free-brands-svg-icons/faFontAwesomeLogoFull'
    ),
    'glide-g': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faGlideG" */
        '@fortawesome/free-brands-svg-icons/faGlideG'
    ),
    'goodreads-g': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faGoodreadsG" */
        '@fortawesome/free-brands-svg-icons/faGoodreadsG'
    ),
    'hacker-news-square': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faSquareHackerNews" */
        '@fortawesome/free-brands-svg-icons/faSquareHackerNews'
    ),
    'hubspot': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faHubspot" */
        '@fortawesome/free-brands-svg-icons/faHubspot'
    ),
    'ioxhost': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faIoxhost" */
        '@fortawesome/free-brands-svg-icons/faIoxhost'
    ),
    'less': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faLess" */
        '@fortawesome/free-brands-svg-icons/faLess'
    ),
    'linux': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faLinux" */
        '@fortawesome/free-brands-svg-icons/faLinux'
    ),
    'meta': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faMeta" */
        '@fortawesome/free-brands-svg-icons/faMeta'
    ),
    'nimblr': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faNimblr" */
        '@fortawesome/free-brands-svg-icons/faNimblr'
    ),
    'odnoklassniki-square': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faSquareOdnoklassniki" */
        '@fortawesome/free-brands-svg-icons/faSquareOdnoklassniki'
    ),
    'page4': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faPage4" */
        '@fortawesome/free-brands-svg-icons/faPage4'
    ),
    'phoenix-framework': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faPhoenixFramework" */
        '@fortawesome/free-brands-svg-icons/faPhoenixFramework'
    ),
    'php': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faPhp" */
        '@fortawesome/free-brands-svg-icons/faPhp'
    ),
    'pinterest-p': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faPinterestP" */
        '@fortawesome/free-brands-svg-icons/faPinterestP'
    ),
    'pinterest-square': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faSquarePinterest" */
        '@fortawesome/free-brands-svg-icons/faSquarePinterest'
    ),
    'ravelry': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faRavelry" */
        '@fortawesome/free-brands-svg-icons/faRavelry'
    ),
    'redhat': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faRedhat" */
        '@fortawesome/free-brands-svg-icons/faRedhat'
    ),
    'replyd': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faReplyd" */
        '@fortawesome/free-brands-svg-icons/faReplyd'
    ),
    'slideshare': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faSlideshare" */
        '@fortawesome/free-brands-svg-icons/faSlideshare'
    ),
    'snapchat': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faSnapchatGhost" */
        '@fortawesome/free-brands-svg-icons/faSnapchatGhost'
    ),
    'square-github': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faSquareGithub" */
        '@fortawesome/free-brands-svg-icons/faSquareGithub'
    ),
    'square-gitlab': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faSquareGitlab" */
        '@fortawesome/free-brands-svg-icons/faSquareGitlab'
    ),
    'stackpath': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faStackpath" */
        '@fortawesome/free-brands-svg-icons/faStackpath'
    ),
    'staylinked': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faStaylinked" */
        '@fortawesome/free-brands-svg-icons/faStaylinked'
    ),
    'stumbleupon-circle': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faStumbleuponCircle" */
        '@fortawesome/free-brands-svg-icons/faStumbleuponCircle'
    ),
    'superpowers': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faSuperpowers" */
        '@fortawesome/free-brands-svg-icons/faSuperpowers'
    ),
    'vnv': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faVnv" */
        '@fortawesome/free-brands-svg-icons/faVnv'
    ),
    'weebly': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faWeebly" */
        '@fortawesome/free-brands-svg-icons/faWeebly'
    ),
    'yandex': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faYandex" */
        '@fortawesome/free-brands-svg-icons/faYandex'
    ),
} as Record<string, ()=>Promise<{ definition: IconDefinition }>>